// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {checkForDuplicateClaims} from '../services/check-for-duplicate-claims';
import {getNewSystemSelectedClaims} from '../../shared/repositories';

export const readNewSystemSelectedClaims = (fromDate, toDate, audit) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const existingUserSelectedClaims = audit.claims.filter(claim => !claim.isSystemSelected);

        try {

            const data = await getNewSystemSelectedClaims(fromDate, toDate, audit.accounts);

            if (existingUserSelectedClaims.length) {

                dispatch({
                    claims: checkForDuplicateClaims(audit, data),
                    type: actions.REPLACE_TCSM_PREPARE_AUDIT_CLAIMS
                });

            } else {

                dispatch({
                    claims: data.claims,
                    type: actions.REPLACE_TCSM_PREPARE_AUDIT_CLAIMS
                });

            }

            dispatch({
                type: actions.UPDATE_TCSM_PREPARE_AUDIT_USER_SELECTED_CLAIMS_MINIMUM,
                userSelectedClaimsMinimum: data.userSelectedClaimsMinimum
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/action-creators/get-new-system-selected-claims.js